import * as React from 'react';
import { useLocation, useParams } from 'react-router';
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from '@/components/ui/breadcrumb';
import { Link } from 'react-router';
import { useAccount } from '@/hooks/account/useAccount';

export function Breadcrumbs() {
  const location = useLocation();
  const { accountId } = useParams<{ accountId: string }>();
  const { account } = useAccount(accountId || '');

  const paths = location.pathname.split('/').filter(Boolean);

  // Create paths mapping for readable names
  const pathMapping: Record<string, string> = {
    transactions: 'Transactions',
    queued: 'Queued',
    historic: 'Historic',
    policies: 'Policies',
    groups: 'Groups',
    members: 'Members',
    'address-book': 'Address Book',
    settings: 'Settings',
    organization: 'Organization',
    personal: 'Personal',
    billing: 'Billing',
    accounts: 'Accounts',
  };

  // If we're at the root, don't show anything (it will redirect to transactions)
  if (paths.length === 0) {
    return null;
  }

  return (
    <Breadcrumb className="py-3">
      <BreadcrumbList>
        {paths.map((path, index) => {
          const isLast = index === paths.length - 1;
          let displayName = pathMapping[path] || path;

          // Special handling for account detail pages
          if (
            paths[index - 1] === 'accounts' &&
            accountId &&
            path === accountId &&
            account
          ) {
            displayName = account.name;
          }

          const href = `/${paths.slice(0, index + 1).join('/')}`;

          return (
            <React.Fragment key={path}>
              {index > 0 && <BreadcrumbSeparator />}
              <BreadcrumbItem>
                {isLast ? (
                  <BreadcrumbPage>{displayName}</BreadcrumbPage>
                ) : (
                  <BreadcrumbLink asChild>
                    <Link to={href}>{displayName}</Link>
                  </BreadcrumbLink>
                )}
              </BreadcrumbItem>
            </React.Fragment>
          );
        })}
      </BreadcrumbList>
    </Breadcrumb>
  );
}
